import { $win, $body, $doc } from '../utils/globals';
import isMobile from '../utils/isMobile';

$('.js-has-dropdown')
  .on('mouseover', function () {
    if ($win.width() > 1024) {
      $(this).closest('.js-nav').addClass('is-hovered');
    }
  })
  .on('mouseout', function () {
    if ($win.width() > 1024) {
      $(this).closest('.js-nav').removeClass('is-hovered');
    }
  });
